module.exports = __webpack_public_path__ + "static/img/10.2a24acc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/7/zh/10.png
// module id = JkN6
// module chunks = 0